import api from './api';
import type { JobListResponse, UploadPhotoResponse, MatchStatusResponse, MatchResultsResponse } from '../types/api';

export async function listJobs(): Promise<JobListResponse> {
  const r = await api.get<{ success: boolean; data: JobListResponse }>('/api/v1/jobs/list');
  return r.data.data;
}

export async function uploadPhoto(file: File, jobId?: string): Promise<UploadPhotoResponse> {
  const form = new FormData();
  form.append('file', file);
  if (jobId) form.append('job_id', jobId);
  const r = await api.post<UploadPhotoResponse>('/api/v1/jobs/upload-photo', form);
  return r.data;
}

export async function getMatchStatus(uploadId: string): Promise<MatchStatusResponse> {
  const r = await api.get<MatchStatusResponse>(`/api/v1/jobs/match-status/${uploadId}`);
  return r.data;
}

export async function getMatchResults(uploadId: string): Promise<MatchResultsResponse> {
  const r = await api.get<MatchResultsResponse>(`/api/v1/jobs/match-results/${uploadId}`);
  return r.data;
}
